import { h } from 'preact';
import { SearchInput } from '../SearchInput';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'SearchInput',
  category: '📝 Formulários',
  description: 'Input de busca com debounce e ícone de lupa integrado',
  usedIn: ['AgentesPage', 'Integrations', 'ChatHubPage'],
  example: () => (
    <SearchInput placeholder="Buscar usuarios..." onSearch={(v) => console.log(v)} debounceMs={300} />
  ),
};
